export const dataGridOperators = {
  EQUAL: 'equals',
  CONTAINS: 'contains',
  ANY_OF: 'isAnyOf',
} as const;
